/* globals require */
/* exported app */

import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import store from './store';
import './forms';
import VueClazyLoad from 'vue-clazy-load';
import 'intersection-observer';
import './polyfills';
import { showAt, hideAt, withBreakpoint } from './apps/breakpoints';
import SocialSharing from 'vue-social-sharing';

Vue.component('parallax', require('./apps/parallax.vue'));
Vue.component('accordion', require('./apps/accordion.vue'));
Vue.component('show-at', showAt);
Vue.component('hide-at', hideAt);
Vue.component('with-breakpoint', withBreakpoint);
Vue.component('watch-scroll', require('./apps/watch-scroll.vue'));
Vue.component('accordion-item', require('./apps/accordion-item.vue'));
Vue.component('tabs', require('./apps/tabs.vue'));
Vue.component('tab', require('./apps/tab.vue'));
Vue.component('background-video', require('./vendor/backgroundVideo.vue'));
Vue.component('contact-selector', require('./apps/contact-selector.vue'));
Vue.component('dropdown', require('./apps/dropdown.vue'));
Vue.component('dropup', require('./apps/dropup.vue'));
Vue.component('pagination', require('./apps/pagination.vue'));
Vue.component('pinch-image', require('./apps/pinch-image.vue'));
Vue.component('slick', require('./vendor/slick.vue'));
Vue.component('static-map', require('./apps/static-map.vue'));
Vue.component('toggle-buttons', require('./apps/toggle-buttons.vue'));
Vue.component('toggle-buttons-metro', require('./apps/toggle-buttons-metro.vue'));
Vue.component('homepage-carousel', require('./apps/homepage-carousel.vue'));
Vue.component('city-landing-page-map', require('./apps/city-landing-page-map.vue'));
Vue.component('regional-landing-page-tab-toggle', require('./apps/regional-landing-page-tab-toggle.vue'));
Vue.component('open-modal', require('./apps/open-modal.vue'));
Vue.component('dropdown-select', require('./atoms/dropdown-select.vue'));
Vue.component('modal-residence-gallery', require('./apps/modal-residence-gallery.vue'));
Vue.component('community-nav', require('./apps/community-nav.vue'));
Vue.component('mortgage-calculator', require('./apps/mortgage-calculator.vue'));
Vue.component('calculator', require('./apps/calculator.vue'));
Vue.component('floorplan-image-gallery', require('./apps/floorplan-image-gallery.vue'));
Vue.component('community-gallery', require('./apps/community-gallery.vue'));
Vue.component('contact-and-directions-map', require('./apps/contact-and-directions-map.vue'));
Vue.component('video-modal', require('./apps/video-modal.vue'));
Vue.component('community-amenities', require('./apps/community-amenities.vue'));
Vue.component('native-select', require('./atoms/native-select.vue'));
Vue.component('floorplans-filter', require('./pages/floorplans/floorplans-filter.vue'));
Vue.component('doughnut-chart', require('./apps/chart.vue'));
Vue.component('media-gallery', require('./apps/media-gallery.vue'));
Vue.component('contact', require('./apps/contact.vue'));
Vue.component('siteplan-map', require('./apps/siteplan-map.vue'));
Vue.component('community-card', require('./apps/community-card.vue'));
Vue.component('where-we-build-map', require('./apps/where-we-build-map.vue'));
Vue.component('floorplan-detail', require('./apps/floorplan-detail.vue'));
Vue.component('community-gallery-images', require('./apps/community-gallery-images.vue'));
Vue.component('marketing-gallery-images', require('./apps/marketing-gallery-images.vue'));
Vue.component('modal-new-home-gallery', require('./apps/modal-new-home-gallery.vue'));
Vue.component('interior-designs', require('./apps/interior-designs.vue'));
Vue.component('mlp-map', require('./apps/mlp-map.vue'));
Vue.component('view-available-homes', require('./apps/view-available-homes.vue'));
Vue.component('community-move-in-ready', require('./apps/community-move-in-ready.vue'));
Vue.component('community-floorplans', require('./apps/community-floorplans.vue'));
Vue.component('move-in-ready', require('./apps/move-in-ready.vue'));
Vue.component('home-lot-map', require('./apps/home-lot-map.vue'));
Vue.component('truncate', require('./apps/truncate.vue'));
Vue.component('announcements', require('./apps/announcements.vue'));
Vue.component('cookie-consent', require('./apps/cookie-consent.vue'));

Vue.component('dynamic', {
    functional: true,
    template: '#dynamic',
    props: ['template', 'openModal', 'options', 'modalOpen', 'closeModal'],
    render(h, context) {
        const template = context.props.template;
        const openModal = context.props.openModal;
        const modalOpen = context.props.modalOpen;
        const closeModal = context.props.closeModal;
        const options = context.props.options;
        const component = template
            ? {
                  template: template,
                  data() {
                      return { openModal, options, modalOpen, closeModal };
                  },
              }
            : { template: `<div>Loading...</div>` };
        return h(component);
    },
});

Vue.directive('scroll-to', require('./vue-directives/scrollTo.vue'));
Vue.directive('tabs', require('./vue-directives/tabs.vue'));
Vue.directive('lazy-load', require('./vue-directives/lazyload.vue'));
Vue.directive('sticky-nav', require('./vue-directives/stickyNav.vue'));
Vue.directive('range', require('./vue-directives/range.vue'));
Vue.mixin({
    mixins: [withBreakpoint],
    methods: {
        srcSet(imgSet, lowestQuality, prefix) {
            let fallbackImage = null;
            let size = lowestQuality || 'small';
            const lq = lowestQuality || 'original';
            switch (this.currentBreakpoint) {
                case 'infinite':
                    size = 'original';
                    break;
                case 'desktop':
                    size = lq === 'hd' ? lq : 'hd';
                    break;
                case 'tablet':
                    size = lq === 'hd' || lq === 'large' ? lq : 'large';
                    break;
                case 'phone':
                    size = lq === 'hd' || lq === 'large' || lq === 'medium' ? lq : 'medium';
                    break;
            }
            if ((prefix && !imgSet[prefix]) || !imgSet[size]) {
                fallbackImage = imgSet.img || imgSet.image;
            }
            if (fallbackImage) {
                return fallbackImage[size];
            } else {
                return prefix ? imgSet[prefix][size] : imgSet[size];
            }
        },
    },
});

Vue.use(VueClazyLoad);
Vue.use(SocialSharing);

const app = new Vue({
    el: '#app',
    store,
    data: {
        year: new Date().getFullYear(),
        mainNav: false,
        modalOpen: false,
        videoModalOpen: false,
        subNav: false,
        subNavItem: {
            findYourHome: false,
            discoverCasaFresca: false,
            getInspired: false,
            contact: false,
        },
        active: false,
        modalContent: {},
        dropdown: false,
        isActive: false,
        opened: false,
        footerChat: false,
        sidebarSignup: false,
        dynamicMeta: false,
        metroDropdown: false,
        cityDropdown: false,
        baseUrl: `${window.location.origin}${window.location.pathname}`,
        utmSource: '',
        utmMedium: '',
        utmCampaign: '',
        utmContent: '',
        gclid: '',
        wbraid: '',
        gbraid: ''
    },
    delimiters: ['<%', '%>'],
    mixins: [withBreakpoint],
    created() {
        // bind the application-level data to the store
        if (typeof JsonData !== 'undefined') {
            this.fillAppData(JsonData);
        }

        this.$eventsBus.$on('open-modal', ($params) => {
            this.openModal($params[0], $params[1]);
        });

        this.$eventsBus.$on('open-video-modal', ($params) => {
            this.openVideoModal($params[0], $params[1]);
        });

        this.$eventsBus.$on('close-modal', () => {
            this.closeModal();
        });

        this.$eventsBus.$on('toggle-sub-nav', this.toggleSubNav);
        this.$eventsBus.$on('breakpoint-change', this.handleBreakpointChange);

        window.addEventListener('load', () => {
            this.$eventsBus.$emit('ready');
        });
    },
    // mounted() {
    //   const vCloaks = document.querySelectorAll('[v-cloak]');
    //   vCloaks.forEach((vCloak) => {
    //     vCloak.removeAttribute('v-cloak');
    //   });
    // },
    mounted() {
        if(window.location.search) {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get("_source") || urlParams.get("utm_source")) {
                this.utmSource = urlParams.get("_source") || urlParams.get("utm_source");
            }
            if (urlParams.get("_medium") || urlParams.get("utm_medium")) {
                this.utmMedium = urlParams.get("_medium") || urlParams.get("utm_medium");
            }
            if (urlParams.get("_campaign") || urlParams.get("utm_campaign")) {
                this.utmCampaign = urlParams.get("_campaign") || urlParams.get("utm_campaign");
            }
            if (urlParams.get("_content") || urlParams.get("utm_content")) {
                this.utmContent = urlParams.get("_content") || urlParams.get("utm_content");
            }
            
            if (urlParams.get("gclid")) {
                this.gclid = urlParams.get("gclid");
            }
            if (urlParams.get("wbraid")) {
                this.wbraid = urlParams.get("wbraid");
            }
            if (urlParams.get("gbraid")) {
                this.gbraid = urlParams.get("gbraid");
            }
          }
      
          // this.utmSource = localStorage.utmSource ? localStorage.utmSource : this.utmSource;
          // this.utmMedium = localStorage.utmMedium ? localStorage.utmMedium : this.utmMedium;
          // this.utmCampaign = localStorage.utmCampaign ? localStorage.utmCampaign : this.utmCampaign;
          // this.utmContent = localStorage.utmContent ? localStorage.utmContent : this.utmContent;
      
          // this.gclid = localStorage.seGclid ? localStorage.seGclid : this.gclid;
          // this.wbraid = localStorage.seWbraid ? localStorage.seWbraid : this.wbraid;
          // this.gbraid = localStorage.seGbraid ? localStorage.seGbraid : this.gbraid;
    },
    watch: {
        utmSource(newUtmSource) {
          localStorage.setItem("utmSource", newUtmSource);
        },
        utmMedium(newUtmMedium) {
          localStorage.setItem("utmMedium", newUtmMedium);
        },
        utmCampaign(newUtmCampaign) {
          localStorage.setItem("utmCampaign", newUtmCampaign);
        },
        utmContent(newUtmContent) {
            localStorage.setItem("utmContent", newUtmContent);
        },
        gclid(newgclid) {
            localStorage.setItem("seGclid", newgclid);
        },
        wbraid(newwbraid) {
            localStorage.setItem("seWbraid", newwbraid);
        },
        gbraid(newgbraid) {
            localStorage.setItem("seGbraid", newgbraid);
        }
      },
    methods: {
        /**
         * Ensures menu remains closed if toggling between breakpoints
         */
        handleBreakpointChange() {
            if (this.currentBreakpoint !== 'phone' && this.currentBreakpoint !== 'tablet') {
                this.subNav = false;
                Object.keys(this.subNavItem).forEach((key) => {
                    this.subNavItem[key] = false;
                });
            }
        },

        openModal(modal, modalData) {
            this.modalOpen = modal;
            this.setModalData(modalData);
            this.setActiveModal(modal);
        },

        openVideoModal(modal, modalData) {
            this.videoModalOpen = modal;
            this.setModalData(modalData);
            this.setActiveModal(modal);
        },

        openInteractiveTourModal: function(id, event) {
            const mobile = window.matchMedia('(max-width: 767px)');
            const targetLink = this.interactiveTour;
            if (mobile.matches) {
                window.open(targetLink, '_blank');
            } else {
                this.$eventsBus.$emit('open-modal', ['modal-interactive-floorplan', { tour: this.interactiveTour }]);
            }
        },

        closeModal() {
            this.setActiveModal((this.modalOpen = false));
            this.setActiveModal((this.videoModalOpen = false));

            var iframe = document.querySelector('.modal-video iframe');
            if (iframe) {
                var iframeSrc = iframe.src;
                iframe.src = iframeSrc;
            }
        },
        isModalOpen(modal) {
            return this.modalOpen === modal;
        },
        toggleSubNav(menu) {
            this[menu] = !this[menu];
            Object.keys(this.subNavItem).forEach((key) => {
                this.subNavItem[key] = false;
            });
        },
        toggleSubNavItem(menu) {
            Object.keys(this.subNavItem).forEach((key) => {
                this.subNavItem[key] = key === menu ? !this.subNavItem[key] : false;
            });
        },
        ...mapActions({
            fillAppData: 'app/fill',
            addAppAttribute: 'app/put',
            setModalData: 'modal/setData',
            mergeModalData: 'modal/merge',
            setActiveModal: 'modal/setActive',
        }),
    },
    computed: {
        ...mapGetters({
            appData: 'app/getData',
            modalData: 'modal/getData',
        }),
    },
});



// WEBPACK FOOTER //
// ./resources/components/app.js